export default __webpack_public_path__ + "static/media/metamask-setup_image_5.7e23bb47.jpg";